export const PORTFOLIO_STATUS_LOADING = Symbol('Loading portfolio status');
export const PORTFOLIO_STATUS_NONE = Symbol('Not using portfolio');
export const PORTFOLIO_STATUS_STUDENT = Symbol('Student with portfolio');
export const PORTFOLIO_STATUS_PARENT = Symbol('Parent with children with portfolio');
export const PORTFOLIO_STATUS_SUBSCRIBER = Symbol('Employee with classes with portfolio');
export const PORTFOLIO_STATUS_PILOT = Symbol('Employee with classes with portfolio pilot');
